import { render } from "./PackagesSection.vue?vue&type=template&id=21604ba0"
import script from "./PackagesSection.vue?vue&type=script&lang=js"
export * from "./PackagesSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__